import _asyncToGenerator from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import _regeneratorRuntime from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/regenerator";
// https://observablehq.com/@markusschanta/sailing-lazy@1120
import define1 from "./4fb6c0f09fc8ce7a@2289.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject || (_templateObject = _taggedTemplateLiteral(["# Sailing (Lazy)"])));
  });
  main.variable(observer("viewof date")).define("viewof date", ["select", "urls"], function (select, urls) {
    return select({
      title: "Trip",
      options: Object.keys(urls),
      value: Object.keys(urls).slice(-1)[0]
    });
  });
  main.variable(observer("date")).define("date", ["Generators", "viewof date"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("viewof map")).define("viewof map", ["DOM", "leaflet", "lat_long", "feature_group"], /*#__PURE__*/_regeneratorRuntime.mark(function _callee(DOM, leaflet, lat_long, feature_group) {
    var width, container, map, tileUrl, base, course;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            width = 960;
            container = DOM.element('div', {
              style: "width:".concat(width, "px;height:").concat(width / 2, "px")
            });
            _context.next = 4;
            return container;

          case 4:
            map = container.value = leaflet.map(container).setView([lat_long[0][0], lat_long[0][1]], 13);
            tileUrl = 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png';
            base = leaflet.tileLayer(tileUrl).addTo(map);
            feature_group.addTo(map);
            course = leaflet.polyline(lat_long, {
              weight: 1,
              color: '#333',
              dashArray: '4'
            });
            course.addTo(map);
            map.fitBounds(leaflet.polyline(lat_long).getBounds());

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  main.variable(observer("map")).define("map", ["Generators", "viewof map"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("viewof time_slider")).define("viewof time_slider", ["slider", "file"], function (slider, file) {
    var s = slider({
      min: 0,
      max: file.length - 1,
      step: 1,
      value: 0,
      format: function format(v) {
        return "";
      }
    });
    s.querySelector('input').style.width = "895px";
    s.querySelector('input').style.margin = "20px 31px 0px";
    return s;
  });
  main.variable(observer("time_slider")).define("time_slider", ["Generators", "viewof time_slider"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("viewof velocity_chart")).define("viewof velocity_chart", ["vega_embed", "file"], function (vega_embed, file) {
    return vega_embed({
      layer: [{
        mark: "line",
        data: {
          name: "values",
          values: file
        },
        encoding: {
          x: {
            field: "time",
            type: "temporal",
            title: "",
            axis: {
              format: '%H:%M'
            }
          },
          y: {
            field: "speed_smooth_knots",
            type: "quantitative",
            title: "VOG (kts)"
          }
        }
      }, {
        mark: "rule",
        data: {
          name: "rule_values",
          values: {
            time: file[100]['time']
          }
        },
        encoding: {
          x: {
            field: "time",
            type: "temporal"
          }
        }
      }],
      width: 880,
      height: 100
    }, {
      actions: false
    });
  });
  main.variable(observer("velocity_chart")).define("velocity_chart", ["Generators", "viewof velocity_chart"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("velocity_chart_updater")).define("velocity_chart_updater", ["file", "time_slider", "vega_embed", "velocity_chart"], function (file, time_slider, vega_embed, velocity_chart) {
    var slider_time = {
      time: file[time_slider]['time']
    };
    var changeSet = vega_embed.vega.changeset().remove(vega_embed.vega.truthy).insert(slider_time);
    velocity_chart.change('rule_values', changeSet).run();
    return changeSet;
  });
  main.variable(observer("feature_group_updater")).define("feature_group_updater", ["feature_group", "lat_long", "time_slider", "leaflet", "map"], function (feature_group, lat_long, time_slider, leaflet, map) {
    feature_group.clearLayers();
    var filtered = lat_long.slice(0, time_slider);
    var boat_marker = leaflet.circleMarker(lat_long[time_slider], {
      radius: 8,
      color: '#FFF',
      fillColor: '#FFF',
      fillOpacity: 0.5
    }).addTo(map);
    return feature_group.addLayer(boat_marker);
  });
  main.variable(observer("feature_group")).define("feature_group", ["leaflet"], function (leaflet) {
    return leaflet.featureGroup();
  });
  main.variable(observer("lat_long")).define("lat_long", ["file"], function (file) {
    return file.map(function (elem) {
      return [parseFloat(elem['latitude']), parseFloat(elem['longitude'])];
    });
  });
  main.variable(observer("urls")).define("urls", function () {
    return {
      "2020-07-12 10:46": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2020-07-12%2010_46_30.csv",
      "2020-07-19 11:48": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2020-07-19%2011_48_40.csv",
      "2020-08-01 10:36": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2020-08-01%2010_36_41.csv",
      "2020-08-09 10:24": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2020-08-09%2010_24_30.csv",
      "2020-09-19 14:23": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2020-09-19%2014_23_30.csv",
      "2021-05-16 14:23": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2021-05-16%2012_41_00.csv",
      "2021-06-05 10:23": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2021-06-05%2009_22_42.csv",
      "2021-06-20 12:32": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2021-06-20%2012_32_22.csv",
      "2021-07-31 12:32": "https://raw.githubusercontent.com/markusschanta/sailing/master/data/2021-07-31%2011_05_58.csv"
    };
  });
  main.define("initial loaded", function () {
    return {};
  });
  main.variable(observer("mutable loaded")).define("mutable loaded", ["Mutable", "initial loaded"], function (M, _) {
    return new M(_);
  });
  main.variable(observer("loaded")).define("loaded", ["mutable loaded"], function (_) {
    return _.generator;
  });
  main.variable(observer("file")).define("file", ["date", "loaded", "mutable loaded", "d3", "urls"], /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(date, loaded, $0, d3, urls) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (date in loaded) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return d3.csv(urls[date]);

            case 3:
              $0.value[date] = _context2.sent;

            case 4:
              return _context2.abrupt("return", loaded[date]);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2, _x3, _x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }());
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["## Imports"])));
  });
  var child1 = runtime.module(define1);
  main.import("slider", child1);
  main.import("select", child1);
  main.variable(observer("vega_embed")).define("vega_embed", ["require"], function (require) {
    return require('vega-embed');
  });
  main.variable(observer("d3")).define("d3", ["require"], function (require) {
    return require("d3@5");
  });
  main.variable(observer("leaflet")).define("leaflet", ["require"], function (require) {
    return require('leaflet@1.2.0');
  });
  main.variable(observer("leaflet_css")).define("leaflet_css", ["html", "resolve"], function (html, resolve) {
    return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<link href='", "' rel='stylesheet' />"])), resolve('leaflet@1.2.0/dist/leaflet.css'));
  });
  return main;
}